export default __webpack_public_path__ + "2a842beec8a25a44d5ccb7d61bbe692c.png";